<template>
  <div class="logo">
    <img
      src="https://storage.googleapis.com/storage.codementum.com/studio/public/vendor/img/logo-float.png"
      alt="Codementum Logo"
      height="35"
    />
    <div id="logoText">Codementum</div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.logo {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  margin-top: 0;
  max-height: 45px;
  cursor: pointer;
  display: flex;
  height: 45px;
}

img {
  margin-left: 0.5rem;
  display: inline-flex;
  align-self: center;
}

#logoText {
  font-family: grobold;
  font-size: 24px;
  color: #fff8e9;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left: 0.5rem;
  display: inline-flex;
  align-self: center;
}

.extras {
  display: flex;
  align-items: center;
  color: #fff8e9;
  margin-inline-start: 1rem;
}

#schoolName {
  display: inline-flex;
  max-width: 120px;
  color: #ffffff;
  margin-left: 0.5em;
}
</style>

<style>
/* Override CodementumNavbarHeader */
header#CodementumNavbarHeader {
  position: fixed;
  z-index: 100;
  width: 100%;
  background-color: #0000002e !important;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

header#CodementumNavbarHeader a.logo {
  display: none !important;
}

header#CodementumNavbarHeader .extra-image-name {
  margin-left: 205px !important;
}

header#CodementumNavbarHeader > .user-settings {
  margin-right: 0 !important;
  padding: 0 20px;
}

header#CodementumNavbarHeader > .user-settings > .video {
  margin-left: 0.5rem;
  border: none;
  cursor: pointer;
}

@keyframes highlight-link {
  0% {
    background-color: #ffffff2e;
    box-shadow: none;
    transform: scale(1);
  }

  /* Pulse 1: 0s to 1s mark (approx 3.3%) */
  1.5% {
    background-color: #28a745;
    box-shadow: 0 0 15px #28a745;
    transform: scale(1.08);
  }

  3% {
    background-color: #ffffff2e;
    box-shadow: none;
    transform: scale(1);
  }

  /* Pulse 2: 1s to 2s mark (approx 6.6%) */
  4.5% {
    background-color: #28a745;
    box-shadow: 0 0 15px #28a745;
    transform: scale(1.08);
  }

  6% {
    background-color: #ffffff2e;
    box-shadow: none;
    transform: scale(1);
  }

  100% {
    background-color: #ffffff2e;
    box-shadow: none;
    transform: scale(1);
  }
}

header#CodementumNavbarHeader > .user-settings > .link {
  font-size: 15px;
  border-radius: 5px;
  background-color: #ffffff2e;
  border-color: #ffffff2e;
  display: inline-block;
  color: white;
  text-align: center;
  text-decoration: none;
  padding: 7px 10px;
  transition: 0.3s;
  animation: highlight-link 30s 5s infinite;
}

header#CodementumNavbarHeader > .user-settings > .link:hover {
  background-color: #28a745 !important;
  animation: none;
}

header#CodementumNavbarHeader > .user-settings > .link > span {
  margin-left: 10px;
}

header#CodementumNavbarHeader ul {
  line-height: 1;
  display: flex;
  align-items: center;
}

header#CodementumNavbarHeader ul li :is(a, .dropbtn) {
  height: unset !important;
  padding: 13px 10px !important;
}

header#CodementumNavbarHeader ul li :is(a, .dropbtn):hover {
  background-color: #ffffff2e !important;
}

header#CodementumNavbarHeader ul li .dropdown-content {
  top: 40px !important;
}

header#CodementumNavbarHeader ul li .dropdown-content > a:hover {
  background-color: #f1f1f1 !important;
}

header#CodementumNavbarHeader ul li .purchase-button {
  display: flex !important;
  align-items: center;
  gap: 4px;
  height: unset !important;
  padding: 5px 10px !important;
}
</style>
